import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { auth } from './firebase/init';
import './registerServiceWorker'
import './assets/tailwind.css'
import './assets/styles/variables.css'

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = createApp(App).use(router).use(store).mount('#app');
  }
});
